export default __webpack_public_path__ + "abfd7dc1163a86868322a4b2b34ffa58.svg";